import { Form, Row } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import isinValidation from 'utils/validations/isinValidation';

import AlertComponent from './AlertComponent';
import IsinTable from './IsinTable';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF1 {}

const F1: React.FC<IF1> = () => {
    const [form] = Form.useForm();
    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();
    const [dateLimits, dateLoading] = useDateLimit();
    const [showIsinTable, setShowIsinTable] = useState<boolean>(false);

    useEffect(() => {
        !dateLoading &&
            dateLimits?.ucetniden &&
            form.setFieldsValue({
                datumvypocet: dayjs(dateLimits?.ucetniden).format('DD.MM.YYYY')
            });
        // eslint-disable-next-line
    }, [dateLoading, dateLimits]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        const dataToSend = {
            isin: fieldsValue.isin,
            datroz: fieldsValue.datroz.format('YYYY-MM-DD')
        };
        onFormSubmit(dataToSend);
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F1A" />{' '}
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                            id="f1aZpetBtn"
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            {showIsinTable ? (
                                <IsinTable upperForm={form} setShowIsinTable={setShowIsinTable} formIsinName={'isin'} />
                            ) : (
                                <>
                                    <LoadingWrapper loading={dateLoading}>
                                        <InputComponent
                                            label="DUVERNE_INFO_PODATUM"
                                            name="datumvypocet"
                                            notRequired={true}
                                            disabled={true}
                                        />
                                        <DatePickerComponent
                                            name="datroz"
                                            label="DUVERNE_INFO_POZADOVANY_DEN"
                                            disabledDate={current => current > dayjs(dateLimits?.ucetniden)}
                                            disabled={currentStep > 0}
                                        />
                                    </LoadingWrapper>
                                    <InputComponent
                                        label="ISIN"
                                        name="isin"
                                        type="text"
                                        maxLength={12}
                                        rules={isinValidation()}
                                        capitalize={true}
                                        disabled={currentStep > 0}
                                    />
                                    {currentStep === 0 && (
                                        <>
                                            <ButtonComponent
                                                buttontext="DUVERNE_INFO_ISIN_BUTTON"
                                                onClick={() => setShowIsinTable(true)}
                                                style={{
                                                    position: 'relative',
                                                    top: -12
                                                }}
                                                id="f1aIsinBtn"
                                            />
                                            <ButtonComponent
                                                buttontext="ODESLAT"
                                                onClick={() => form.submit()}
                                                id="f1aOdeslatBtn"
                                            />
                                        </>
                                    )}
                                    {currentStep !== 0 && upozorneni && (
                                        <AlertComponent
                                            upozorneni={upozorneni}
                                            type={currentStep === 1 ? 'error' : 'info'}
                                        />
                                    )}
                                    {currentStep === 1 && (
                                        <Row className="button-row">
                                            <ButtonComponent
                                                buttontext="ZPET"
                                                id="f1aZpetAltBtn"
                                                onClick={() => prev()}
                                                type="default"
                                            />
                                            <ButtonComponent
                                                buttontext="POTVRDIT"
                                                onClick={() => form.submit()}
                                                id="f1aPotvrditBtn"
                                            />
                                        </Row>
                                    )}
                                </>
                            )}
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F1;
